import axios from "axios";
import { Spinner } from 'reactstrap';
import React, { useState, useEffect } from "react";
import Comment from "../Comment";

function Comments({ id }) {

    const [comments, setComments] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function getAllComments() {
            const { data } = await axios.get(`${process.env.REACT_APP_JSON_API_GET_COMMENT}${id}`);
            setComments(data.data)
            setLoading(false)
        }
        if (comments.length == 0) {
            getAllComments()
        }
    }, [])

    return (
        <>

            {loading ? (
                <div className="row">
                    <Spinner color="primary" />
                </div>
            ) :
                comments.length == 0 ? (
                    <p><b>No hay comentarios, se tú el primero en comentar.</b></p>
                ) :
                    (
                        comments.map(comment => {
                            return <Comment comment={comment} />
                        })
                    )
            }
        </>
    )
}

export default Comments